/* ============================================================================
   Petpal SHOP / COLLECTION JS — ported from "Shop.dc.html".
   Header/logo/nav/footer/cart responsive logic lives in pp-theme.js (global) — NOT here.
   This file owns ONLY the shop body:
     • responsive product grid (data-pgrid: 2-up mobile / 3-up tablet / 4-up desktop),
     • the pet toggle + concern chips (active state + live in-grid filtering),
     • count line + empty-filter state.
   Products are rendered server-side by pp-collection.liquid with data-concern + data-pet
   stamped on every card; this reads ?concern / ?pet from the URL and filters instantly,
   mirroring the render's client-side setState filter (chips remain real links w/o JS).
   ========================================================================== */
(function () {
  function ready(fn){ document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn); }
  function icons(){ if (window.lucide && window.lucide.createIcons) { try { window.lucide.createIcons(); } catch(e){} } }

  var state = { pet: 'all', concern: 'All' };

  /* ---- responsive product grid (mirrors the render's applyResponsive) ---- */
  function applyResponsive() {
    var w = window.innerWidth, mob = w <= 640, tab = w <= 960;
    var grid = document.querySelector('[data-pgrid]');
    if (grid) grid.style.gridTemplateColumns = mob ? '1fr 1fr' : (tab ? 'repeat(3,1fr)' : 'repeat(4,1fr)');
  }

  /* ---- chip / toggle styling (verbatim from the render) ---- */
  function petStyle(on){
    return on
      ? "background:#001f36;color:#fff;border:0;border-radius:99px;padding:9px 20px;font-family:'Hanken Grotesk',sans-serif;font-size:13.5px;font-weight:600;cursor:pointer;display:inline-flex;align-items:center;gap:7px;transition:.18s;box-shadow:0 4px 12px rgba(0,31,54,.22);text-decoration:none"
      : "background:transparent;color:#5b6b7a;border:0;border-radius:99px;padding:9px 20px;font-family:'Hanken Grotesk',sans-serif;font-size:13.5px;font-weight:600;cursor:pointer;display:inline-flex;align-items:center;gap:7px;transition:.18s;text-decoration:none";
  }
  function chipStyle(on){
    return on
      ? "background:#001f36;color:#F5F3EE;border:1.5px solid #001f36;border-radius:99px;padding:9px 16px;font-family:'Hanken Grotesk',sans-serif;font-size:13px;font-weight:600;cursor:pointer;transition:.18s;display:inline-flex;align-items:center;gap:7px;box-shadow:0 4px 12px rgba(0,31,54,.16);text-decoration:none"
      : "background:#fff;color:#5b6b7a;border:1.5px solid #ece4d6;border-radius:99px;padding:9px 16px;font-family:'Hanken Grotesk',sans-serif;font-size:13px;font-weight:500;cursor:pointer;transition:.18s;display:inline-flex;align-items:center;gap:7px;text-decoration:none";
  }

  function apply() {
    var cards = document.querySelectorAll('[data-pcard]');
    var shown = 0;
    cards.forEach(function (c) {
      var okPet = state.pet === 'all' || (' ' + (c.getAttribute('data-pet') || '') + ' ').indexOf(' ' + state.pet + ' ') !== -1;
      var okCon = state.concern === 'All' || c.getAttribute('data-concern') === state.concern;
      var vis = okPet && okCon;
      c.style.display = vis ? 'flex' : 'none';
      if (vis) shown++;
    });

    // pet toggle active state
    document.querySelectorAll('[data-pettoggle] [data-pet]').forEach(function (a) {
      a.setAttribute('style', petStyle(a.getAttribute('data-pet') === state.pet));
    });
    // concern chip active state (+ icon color)
    document.querySelectorAll('[data-concerntabs] [data-concern]').forEach(function (a) {
      var on = a.getAttribute('data-concern') === state.concern;
      a.setAttribute('style', chipStyle(on));
      var ic = a.querySelector('.lic');
      if (ic) ic.style.color = on ? '#D6AB5C' : '#C29A52';
    });

    // count line + empty-filter state
    var count = document.querySelector('[data-countline]');
    if (count) count.textContent = 'Showing ' + shown + ' formula' + (shown !== 1 ? 's' : '');
    var empty = document.querySelector('[data-emptyfilter]');
    var grid = document.querySelector('[data-pgrid]');
    if (empty) empty.style.display = (shown === 0 && cards.length > 0) ? 'block' : 'none';
    if (grid) grid.style.display = (shown === 0 && cards.length > 0) ? 'none' : 'grid';

    icons();
  }

  /* If the chosen concern has no products under the active pet (e.g. Cats + Bundles),
     relax the pet filter to 'all' so the concern's products still show — never a dead-end empty tab. */
  function applyWithFallback() {
    apply();
    if (state.pet !== 'all') {
      var any = false;
      document.querySelectorAll('[data-pcard]').forEach(function (c) { if (c.style.display !== 'none') any = true; });
      if (!any) { state.pet = 'all'; apply(); }
    }
  }

  function readURL() {
    try {
      var q = new URLSearchParams(window.location.search);
      var pet = q.get('pet'), con = q.get('concern');
      if (pet === 'cat' || pet === 'dog') state.pet = pet;
      if (con) state.concern = con;
    } catch (e) {}
  }

  function pushURL() {
    if (!window.history || !window.history.pushState) return;
    var params = [];
    if (state.pet !== 'all') params.push('pet=' + encodeURIComponent(state.pet));
    if (state.concern !== 'All') params.push('concern=' + encodeURIComponent(state.concern));
    var qs = params.length ? '?' + params.join('&') : window.location.pathname;
    try { window.history.replaceState(null, '', params.length ? window.location.pathname + qs : window.location.pathname); } catch (e) {}
  }

  ready(function () {
    applyResponsive();
    readURL();
    applyWithFallback();
    icons();

    // chips + toggle: intercept clicks to filter instantly (still work as links w/o JS)
    document.querySelectorAll('[data-pettoggle] [data-pet]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        state.pet = a.getAttribute('data-pet') || 'all';
        pushURL(); apply();
      });
    });
    document.querySelectorAll('[data-concerntabs] [data-concern]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        state.concern = a.getAttribute('data-concern') || 'All';
        applyWithFallback(); pushURL();
      });
    });

    window.addEventListener('resize', applyResponsive);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(icons);
    [150, 500].forEach(function (t) { setTimeout(icons, t); });
  });
})();
